"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var style_module_scss_1 = __importDefault(require("./style.module.scss"));
var mack_component_library_1 = require("mack-component-library");
var TruckDetails_1 = __importDefault(require("../TruckDetails"));
var PageDataContext_1 = require("~contexts/PageDataContext");
var CustomTruckSlide = function (_a, ref) {
    var subtitle = _a.subtitle, title = _a.title, text = _a.text, image = _a.image, detailSection = _a.detailSection, activeIndex = _a.activeIndex, onNext = _a.onNext, onPrev = _a.onPrev;
    var matchedDevice = (0, mack_component_library_1.useMediaQuery)().matchedDevice;
    var sectionLabel = (0, PageDataContext_1.usePageData)().sectionLabel;
    var isMobile = matchedDevice.includes('mobile');
    var buttonLabel = sectionLabel('curated_choices_page', 'build_button_label');
    return (react_1.default.createElement("div", { className: style_module_scss_1.default.container, ref: ref },
        react_1.default.createElement("div", { className: style_module_scss_1.default.mainContent },
            react_1.default.createElement("div", { className: style_module_scss_1.default.leftText },
                react_1.default.createElement(mack_component_library_1.Text, { className: style_module_scss_1.default.subtitle, type: mack_component_library_1.TextType.Accent1 }, subtitle),
                react_1.default.createElement(mack_component_library_1.Title, { className: style_module_scss_1.default.title, as: isMobile ? 'h4' : 'h1' }, title)),
            text && react_1.default.createElement(mack_component_library_1.RichText, { className: style_module_scss_1.default.desc, value: text })),
        react_1.default.createElement("div", { className: style_module_scss_1.default.driverGallery },
            react_1.default.createElement(mack_component_library_1.DriverGallery, { image: image, index: activeIndex, onNext: onNext, onPrev: onPrev })),
        react_1.default.createElement(TruckDetails_1.default, { specifications: detailSection.specifications, image: detailSection.image, buttonLink: detailSection.buttonLink, buttonLabel: buttonLabel, page: activeIndex })));
};
exports.default = (0, react_1.forwardRef)(CustomTruckSlide);
